module.exports = __webpack_public_path__ + "img/x2000.c35f44d8.png";